module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1158-retro-min.16a27489.jpg";